// Generated by scripts/apply-theme.mjs — active theme: legacy
// Flip themes by re-running the script; do not hand-edit this file.
import config from "./themeConfig";
import { createZintoroTheme, buildEyebrowSx, numericSx } from "./createZintoroTheme";
import { applyOverrides } from "./overrides";

export const tokens = applyOverrides(config);
export const theme = createZintoroTheme(tokens);
export const eyebrowSx = buildEyebrowSx(tokens);
export const mono = tokens.fonts.mono;
export { numericSx };
export default theme;
